import * as Sentry from '@sentry/vue';
import type { InjectionKey } from 'vue';
import { rememberSignInReturn } from '@/helpers/signInReturn';

export const SESSION_EXPIRED_SIGN_IN: InjectionKey<() => void> = Symbol('vpSessionExpiredSignIn');

let signingOut = false;

export const endEmbeddedSession = async () => {
  if (signingOut) {
    return;
  }

  signingOut = true;
  rememberSignInReturn(window.location.pathname + window.location.search + window.location.hash);

  const headers = new Headers({ Accept: 'application/json' });
  const csrfToken = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content;
  if (csrfToken) {
    headers.set('X-CSRF-Token', csrfToken);
  }

  try {
    // Devise answers a JSON sign-out with 204, so a redirect means a before-action refused it.
    const response = await fetch('/user/sign_out', { method: 'DELETE', credentials: 'same-origin', redirect: 'manual', headers });
    if (!response.ok) {
      Sentry.captureMessage(`Rails sign-out failed: ${response.status} ${response.type}`);
    }
  } catch (e) {
    Sentry.captureException(e);
  } finally {
    // Rails still signs the user in by its own session, so /user/sign_in bounces them back until it ends.
    window.location.assign('/user/sign_in');
  }
};
